import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipHorizontalCircle24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFlipHorizontalCircle24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M5.98 14.702a6.6 6.6 0 0 0 12.043 0h1.932a8.4 8.4 0 0 1-7.954 5.699l-.432-.01a8.4 8.4 0 0 1-7.522-5.69zm15.921-3.59a.9.9 0 0 1 0 1.8h-19.8a.901.901 0 0 1 0-1.8zm-9.467-7.5a8.405 8.405 0 0 1 7.523 5.69h-1.934A6.6 6.6 0 0 0 12.001 5.4a6.6 6.6 0 0 0-6.022 3.9H4.046A8.4 8.4 0 0 1 12 3.601z"
            />
        </svg>
    );
}
export default memo(IconFlipHorizontalCircle24);
